export default [
  // 分贝通企业id 746728
  {
    name: '首页',
    icon: 'tripwise-manage icon-shouye',
    url: '/fxxt/index',
    type: 'menu',
    menuId: 1,
    hiddenEnterpriseId: [],
  },
  {
    name: '资源预订',
    icon: 'tripwise-manage icon-yuding',
    url: '/fxxt/TravelBooking',
    type: 'menu',
    menuId: 2,
    hiddenEnterpriseId: [],
  },
  {
    name: '订单列表',
    icon: 'tripwise-manage icon-danju04',
    url: '/fxxt/order/#/hotelOrderManage/orderList',
    routerType: 'micro-app',
    type: 'menu',
    menuId: 3,
    hiddenEnterpriseId: [],
  },
  {
    name: '结算管理',
    icon: 'tripwise-manage icon-danju02',
    url: '/fxxt/manage/#/settlementManage',
    routerType: 'micro-app',
    type: 'menu',
    menuId: 4,
    hiddenEnterpriseId: [],
  },
  // 结算管理自动化
  {
    name: '结算管理自动化',
    icon: 'tripwise-manage icon-repay_fill',
    url: '/fxxt/settlement',
    type: 'menu',
    menuId: 8,
    subs: [
      {
        name: '账单管理',
        icon: '',
        url: '/fxxt/settlement/#/bill',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 64,
        pId: 8,
      },
      {
        name: '发票历史',
        icon: '',
        url: '/fxxt/settlement/#/invoice-history',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 80,
        pId: 8,
      },
      {
        name: '结算规则',
        icon: '',
        url: '/fxxt/settlement/#/rules',
        routerType: 'micro-app',
        type: 'menu',
        menuId: 81,
        pId: 8,
      },
    ],
  },
];
